/**
 * Parseo de fechas que llegan del backend.
 *
 * Las columnas `date` (por ejemplo `closes_at` de las convocatorias) se
 * serializan como `YYYY-MM-DD`, sin hora. `new Date("2026-09-14")` interpreta
 * esa cadena como medianoche UTC, y en America/Bogota (UTC-5) eso es el 13 a
 * las 19:00: la fecha se pinta un dia antes y el conteo de dias cambia a las
 * 19:00 (issue #537). Una fecha sin hora es un dia calendario y se parsea
 * como medianoche local para que se vea igual en cualquier zona horaria.
 *
 * Los timestamps con hora (`datetime` del backend, ISO 8601 con `T`) siguen
 * pasando por `new Date` sin cambios: esos si representan un instante.
 */

const DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/;

export function parseIsoDate(iso: string): Date {
  const m = DATE_ONLY.exec(iso);
  if (m) {
    return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  }
  return new Date(iso);
}

/** `toLocaleDateString("es-CO", opts)` sobre `parseIsoDate`; devuelve la cadena cruda si no es fecha. */
export function formatDateEs(iso: string, opts: Intl.DateTimeFormatOptions): string {
  const d = parseIsoDate(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("es-CO", opts);
}
